import script from "./JobFunction.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFunction.vue?vue&type=script&setup=true&lang=js"

import "./JobFunction.vue?vue&type=style&index=0&id=a4e25fae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4e25fae"]])

export default __exports__